import { Link } from "react-router-dom";
import { useLocalePath, useT } from "../i18n";
import { Logo } from "./Logo";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { useSiteSettings } from "../lib/siteSettings";
import { SOCIALS, whatsappUrl } from "../config/siteConfig";

const COLUMNS = [
  { title: "ui.explore", items: ["inventory", "sourcing", "sell", "export"] },
  { title: "ui.company", items: ["company", "contact"] },
  { title: "ui.legal", items: ["privacy", "legal"] },
];

export const Footer = () => {
  const t = useT();
  const lp = useLocalePath();
  const s = useSiteSettings();
  const phone = s.phone && s.phone !== "To be provided" ? s.phone : "";
  const whatsapp = whatsappUrl(s.whatsapp_number, "");
  const socials = SOCIALS.filter(([k]) => /^https?:\/\//.test(s.social?.[k] || ""));
  return (
    <footer className="border-t border-white/10 bg-ink text-white" data-testid="site-footer">
      <div className="container-x grid gap-14 py-20 md:grid-cols-12 lg:py-24">
        <div className="md:col-span-12 lg:col-span-4">
          <Link to={lp()} data-testid="footer-logo-link" className="inline-block">
            <Logo layout="full" tone="light" className="h-auto w-40 sm:w-44" />
          </Link>
          <p className="mt-8 max-w-xs text-sm text-white/50">{t("footer.tagline")}</p>
        </div>
        {COLUMNS.map((col) => (
          <div key={col.title} className="md:col-span-3 lg:col-span-2">
            <p className="eyebrow mb-6 text-white/40">{t(col.title)}</p>
            <ul className="space-y-3.5">
              {col.items.map((key) => (
                <li key={key}>
                  <Link to={lp(key)} data-testid={`footer-link-${key}`} className="footer-link text-sm text-white/75">
                    {t(`nav.${key}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
        <div className="md:col-span-3 lg:col-span-2" data-testid="footer-contact">
          <p className="eyebrow mb-6 text-white/40">{t("ui.contact")}</p>
          <dl className="space-y-3.5 text-sm">
            <div>
              <dt className="text-white/40">{t("ui.email")}</dt>
              <dd className="text-white/75">{t("ui.toBeProvided")}</dd>
            </div>
            <div>
              <dt className="text-white/40">{t("ui.phone")}</dt>
              <dd className="text-white/75" data-testid="footer-phone">
                {phone ? <a href={`tel:${phone.replace(/[^\d+]/g, "")}`} className="footer-link">{phone}</a> : t("ui.toBeProvided")}
              </dd>
            </div>
            {whatsapp && (
              <div>
                <dt className="text-white/40">WhatsApp</dt>
                <dd><a href={whatsapp} target="_blank" rel="noopener noreferrer" className="footer-link text-white/75" data-testid="footer-whatsapp">{s.whatsapp_number}</a></dd>
              </div>
            )}
            {s.line_url && (
              <div>
                <dt className="text-white/40">LINE</dt>
                <dd><a href={s.line_url} target="_blank" rel="noopener noreferrer" className="footer-link text-white/75" data-testid="footer-line">{t("detail.lineAdd")}</a></dd>
              </div>
            )}
          </dl>
          {socials.length > 0 && (
            <ul className="mt-6 flex flex-wrap gap-x-5 gap-y-2 text-xs" data-testid="footer-socials">
              {socials.map(([key, label]) => (
                <li key={key}><a href={s.social[key]} target="_blank" rel="noopener noreferrer" className="footer-link text-white/60" data-testid={`footer-social-${key}`}>{label}</a></li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x flex flex-col gap-5 py-7 text-xs text-white/45 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} HAROON TRADING 合同会社</p>
          <div className="flex items-center gap-8">
            <span>haroontrading.net</span>
            <LanguageSwitcher id="footer" className="text-white" />
          </div>
        </div>
      </div>
    </footer>
  );
};
